// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.animate {
  transform: translate(0);
  transform-style: preserve-3d;
  background-size: 200% auto;
  animation: textShine 3s ease-in-out infinite alternate;
}

.animate:before {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translate3d(0, 0, -1px);
  background-image: conic-gradient(#9032f5, #ff65e6, #1e1e1e);
  filter: blur(10px);
  background-size: 200% auto;
  animation: rotate-gradient 3s linear infinite;
}
@keyframes textShine {
  0% {
    background-position: 0% 0%;
  }
  25% {
    background-position: 100% 0%;
  }
  75% {
    background-position: 100% 100%;
  }
  100% {
    background-position: 0% 100%;
  }
}
@keyframes rotate-gradient {
  0% {
    background-image: linear-gradient(18deg, #9032f5, #ff65e6, #1e1e1e);
  }
  10% {
    background-image: linear-gradient(36deg, #9032f5, #ff65e6, #1e1e1e);
  }
  15% {
    background-image: linear-gradient(54deg, #9032f5, #ff65e6, #1e1e1e);
  }
  20% {
    background-image: linear-gradient(72deg, #9032f5, #ff65e6, #1e1e1e);
  }
  25% {
    background-image: linear-gradient(90deg, #9032f5, #ff65e6, #1e1e1e);
  }
  30% {
    background-image: linear-gradient(108deg, #9032f5, #ff65e6, #1e1e1e);
  }
  35% {
    background-image: linear-gradient(126deg, #9032f5, #ff65e6, #1e1e1e);
  }
  40% {
    background-image: linear-gradient(144deg, #9032f5, #ff65e6, #1e1e1e);
  }
  45% {
    background-image: linear-gradient(162deg, #9032f5, #ff65e6, #1e1e1e);
  }
  50% {
    background-image: linear-gradient(180deg, #9032f5, #ff65e6, #1e1e1e);
  }
  55% {
    background-image: linear-gradient(198deg, #9032f5, #ff65e6, #1e1e1e);
  }
  60% {
    background-image: linear-gradient(216deg, #9032f5, #ff65e6, #1e1e1e);
  }
  65% {
    background-image: linear-gradient(234deg, #9032f5, #ff65e6, #1e1e1e);
  }
  70% {
    background-image: linear-gradient(252deg, #9032f5, #ff65e6, #1e1e1e);
  }
  75% {
    background-image: linear-gradient(270deg, #9032f5, #ff65e6, #1e1e1e);
  }
  80% {
    background-image: linear-gradient(288deg, #9032f5, #ff65e6, #1e1e1e);
  }
  85% {
    background-image: linear-gradient(306deg, #9032f5, #ff65e6, #1e1e1e);
  }
  90% {
    background-image: linear-gradient(324deg, #9032f5, #ff65e6, #1e1e1e);
  }
  95% {
    background-image: linear-gradient(342deg, #9032f5, #ff65e6, #1e1e1e);
  }

  100% {
    background-image: linear-gradient(0deg, #9032f5, #ff65e6, #1e1e1e);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/common/button/style.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,0BAA0B;EAC1B,sDAAsD;AACxD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAQ;EAAR,QAAQ;EAAR,SAAQ;EAAR,OAAQ;EACR,kCAAkC;EAClC,2DAA2D;EAC3D,kBAAkB;EAClB,0BAA0B;EAC1B,6CAA6C;AAC/C;AACA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,4BAA4B;EAC9B;AACF;AACA;EACE;IACE,mEAAmE;EACrE;EACA;IACE,mEAAmE;EACrE;EACA;IACE,mEAAmE;EACrE;EACA;IACE,mEAAmE;EACrE;EACA;IACE,mEAAmE;EACrE;EACA;IACE,oEAAoE;EACtE;EACA;IACE,oEAAoE;EACtE;EACA;IACE,oEAAoE;EACtE;EACA;IACE,oEAAoE;EACtE;EACA;IACE,oEAAoE;EACtE;EACA;IACE,oEAAoE;EACtE;EACA;IACE,oEAAoE;EACtE;EACA;IACE,oEAAoE;EACtE;EACA;IACE,oEAAoE;EACtE;EACA;IACE,oEAAoE;EACtE;EACA;IACE,oEAAoE;EACtE;EACA;IACE,oEAAoE;EACtE;EACA;IACE,oEAAoE;EACtE;EACA;IACE,oEAAoE;EACtE;;EAEA;IACE,kEAAkE;EACpE;AACF","sourcesContent":[".animate {\n  transform: translate(0);\n  transform-style: preserve-3d;\n  background-size: 200% auto;\n  animation: textShine 3s ease-in-out infinite alternate;\n}\n\n.animate:before {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  transform: translate3d(0, 0, -1px);\n  background-image: conic-gradient(#9032f5, #ff65e6, #1e1e1e);\n  filter: blur(10px);\n  background-size: 200% auto;\n  animation: rotate-gradient 3s linear infinite;\n}\n@keyframes textShine {\n  0% {\n    background-position: 0% 0%;\n  }\n  25% {\n    background-position: 100% 0%;\n  }\n  75% {\n    background-position: 100% 100%;\n  }\n  100% {\n    background-position: 0% 100%;\n  }\n}\n@keyframes rotate-gradient {\n  0% {\n    background-image: linear-gradient(18deg, #9032f5, #ff65e6, #1e1e1e);\n  }\n  10% {\n    background-image: linear-gradient(36deg, #9032f5, #ff65e6, #1e1e1e);\n  }\n  15% {\n    background-image: linear-gradient(54deg, #9032f5, #ff65e6, #1e1e1e);\n  }\n  20% {\n    background-image: linear-gradient(72deg, #9032f5, #ff65e6, #1e1e1e);\n  }\n  25% {\n    background-image: linear-gradient(90deg, #9032f5, #ff65e6, #1e1e1e);\n  }\n  30% {\n    background-image: linear-gradient(108deg, #9032f5, #ff65e6, #1e1e1e);\n  }\n  35% {\n    background-image: linear-gradient(126deg, #9032f5, #ff65e6, #1e1e1e);\n  }\n  40% {\n    background-image: linear-gradient(144deg, #9032f5, #ff65e6, #1e1e1e);\n  }\n  45% {\n    background-image: linear-gradient(162deg, #9032f5, #ff65e6, #1e1e1e);\n  }\n  50% {\n    background-image: linear-gradient(180deg, #9032f5, #ff65e6, #1e1e1e);\n  }\n  55% {\n    background-image: linear-gradient(198deg, #9032f5, #ff65e6, #1e1e1e);\n  }\n  60% {\n    background-image: linear-gradient(216deg, #9032f5, #ff65e6, #1e1e1e);\n  }\n  65% {\n    background-image: linear-gradient(234deg, #9032f5, #ff65e6, #1e1e1e);\n  }\n  70% {\n    background-image: linear-gradient(252deg, #9032f5, #ff65e6, #1e1e1e);\n  }\n  75% {\n    background-image: linear-gradient(270deg, #9032f5, #ff65e6, #1e1e1e);\n  }\n  80% {\n    background-image: linear-gradient(288deg, #9032f5, #ff65e6, #1e1e1e);\n  }\n  85% {\n    background-image: linear-gradient(306deg, #9032f5, #ff65e6, #1e1e1e);\n  }\n  90% {\n    background-image: linear-gradient(324deg, #9032f5, #ff65e6, #1e1e1e);\n  }\n  95% {\n    background-image: linear-gradient(342deg, #9032f5, #ff65e6, #1e1e1e);\n  }\n\n  100% {\n    background-image: linear-gradient(0deg, #9032f5, #ff65e6, #1e1e1e);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
